var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-settings-solid-16",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,8 C13.5020164,7.66455687 13.4718786,7.32969257 13.41,7 L15,5.5 L13.61,3.08 L11.52,3.79 C11.023836,3.38500301 10.4625318,3.06715608 9.86,2.85 L9.4,1 L6.61,1 L6.15,2.85 C5.53067032,3.0780576 4.958009,3.41691045 4.46,3.85 L2.4,3.08 L1,5.5 L2.59,7 C2.52812135,7.32969257 2.49798356,7.66455687 2.5,8 C2.50268942,8.33568965 2.53616296,8.67042512 2.6,9 L1,10.57 L2.39,13 L4.49,12.26 C4.988009,12.6930895 5.56067032,13.0319424 6.18,13.26 L6.64,15 L9.43,15 L9.76,13.21 C10.4127546,12.9888349 11.0194448,12.6499019 11.55,12.21 L13.55,12.91 L15,10.5 L13.41,9 C13.4740923,8.67061781 13.5042499,8.33553298 13.5,8 L13.5,8 Z M8,11 C6.34314575,11 5,9.65685425 5,8 C5,6.34314575 6.34314575,5 8,5 C9.65685425,5 11,6.34314575 11,8 C11,9.65685425 9.65685425,11 8,11 L8,11 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b3e7517912bcfebeb7bbb452ee34d097.svg";
export { ForwardRef as ReactComponent };